export enum TicketsFormat {
    listItem = 'listItem',
    card = 'card',
}

export enum ExpressPaymentMethods {
    gpay = 'gpay',
    paypal = 'paypal',
}

export enum StatsigSynchronousInitializationExperimentVariant {
    unknown = 'unknown',
    control = 'control',
    test = 'test',
}

export enum PostCheckoutMandatoryCustomQuestionsVariant {
    optionalAndCannedQuestions = 'optionalAndCannedQuestions',
    customQuestions = 'customQuestions',
}

export enum PostCheckoutMandatoryQuestionsInAppVariant {
    optionalQuestionsInApp = 'optionalQuestionsInApp',
    optionalAndCannedQuestionsInApp = 'optionalAndCannedQuestionsInApp',
    customQuestionsInApp = 'customQuestionsInApp',
}

export enum FollowCardPlacementExperimentVariant {
    bottomFollowCard = 'bottom',
    topFollowCard = 'top',
}

export enum SHARE_TYPES {
    FACEBOOK = 'facebook',
    FACEBOOK_MESSENGER = 'facebookMessenger',
    TWITTER = 'twitter',
    EMAIL = 'email',
}

export enum ConfirmationPageReferralExperimentVariant {
    control = 'control',
    referralDrawer = 'referralDrawer',
    referralLinkout = 'referralLinkout',
}

export enum ExpressOnlyCheckoutExperimentVariant {
    notEnabled = 'notEnabled',
    enabled = 'enabled',
}

export enum EnhanceLogionOptionExperimentVariant {
    control = 'control',
    faster_experience = 'faster_experience',
    tickets_handy = 'tickets_handy',
    autofill_info = 'autofill_info',
}
